import { PollingStatus, StatusProvider } from '@/tax/models';

export class SharepointSite {
    id?: number;
    displayName?: string;
    siteId: string = '';
    status = PollingStatus.Init;
    statusMessage?: string;

    deserialize(data: any): SharepointSite {
        this.id = data.id;
        this.displayName = data.name;
        this.siteId = data.site_id;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message;
        return this;
    }

    serialize() {
        return {
            site_id: this.siteId,
            name: this.displayName,
            status: this.status,
        };
    }
}
